<!-- 练习历史 -->
<template>
    <div class="wrap">
        <van-sticky>
            <div class="header">
                <NavigateBar :title="'练习历史'" :isTop="true" @handleBack="handleBack"/>
            </div>
            <div class="line"></div>
        </van-sticky>
        <div v-if="historyList.length" class="main">
            <div class="section borderRadius8 colorFFF">
                <div class="sectionLi">
                    <span>及格次数</span>
                    <span class="sectionValue">{{ exerciseData.passNum || 0 }}</span>
                </div>
                <div class="sectionLi">
                    <span>平均分数</span>
                    <span class="sectionValue">{{ exerciseData.average || 0 }}</span>
                </div>
                <div class="sectionLi">
                    <span>最高分数</span>
                    <span class="sectionValue">{{ exerciseData.maxScore || 0 }}</span>
                </div>
            </div>
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <div class="historyDataList">
                    <div class="historyDataLi borderRadius8" v-for="item in historyList" :key="item.id">
                        <div class="actionData borderRadius8">
                            <div class="dataScore">
                                <span>作业分数</span>
                                <div><span class="dataValue">{{ item.score }}</span>分</div>
                            </div>
                            <div class="section">
                                <div class="sectionLi">
                                    <span>总题数</span>
                                    <span class="sectionValue">{{ item.pass_num + item.fail_num + item.short_answer_num }}</span>
                                </div>
                                <div class="sectionLi">
                                    <span>答对数</span>
                                    <span class="sectionValue success">{{ item.pass_num }}</span>
                                </div>
                                <div class="sectionLi">
                                    <span>答错数</span>
                                    <span class="sectionValue fail">{{ item.fail_num }}</span>
                                </div>
                                <div class="sectionLi">
                                    <span>简答题</span>
                                    <span class="sectionValue">{{ item.short_answer_num }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="actionTime">
                            <div class="time">
                                完成时间：<span>{{ item.create_time }}</span>
                            </div>
                            <div class="btn" @click="checkView(item)">查看题目</div>
                        </div>
                        <div class="tag" :class="item.is_pass != 1 ? 'fail' : ''">{{ item.is_pass == 1 ? '及格' : '不及格' }}</div>
                    </div>
                </div>
            </van-pull-refresh>
        </div>
        <van-empty v-if="!historyList.length" description="暂无历史数据" />
    </div>
</template>

<script>
import NavigateBar from './navigateBar.vue';
import Vue from 'vue'
import { Sticky, Empty } from 'vant'
Vue.use(Sticky, Empty) 

export default {
    name: 'HistoryList',
    components:{
        NavigateBar 
    },
    data() {
        return {
            query: {},
            exerciseData: {},
            pagination: {
                page: 1,
                pageNum: 10,
                total: 0,
                pageSize: ''
            },
            historyList: [],
            isLoading: false
        }
    },
    created() {
       const { payload, exerciseData }=this.$route.query
       this.query = JSON.parse(decodeURIComponent(payload))
       this.exerciseData = JSON.parse(decodeURIComponent(exerciseData))
       this.$nextTick(() => {
            this.fetch()
        })
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll,true)
    },
    beforeDestroy(){
        window.removeEventListener("scroll",this.handleScroll,true)
    },
    methods: {
        async fetch() {
            const params = {
                ucq_id: this.query.ucqid,
                page: this.pagination.page,
                page_nums: this.pagination.pageNum
            }
            const res = await this.$api.post('user/question/historyList', params)
            this.pagination.pageSize = (res.data.data.count > 10 ? Math.ceil(res.data.data.count/this.pagination.pageNum) : 1)
            
            if (this.pagination.page === 1) {
                this.historyList = []
            }
            this.historyList = [...this.historyList, ...res.data.data.list]
        },
        handleScroll(){
            let dom = window.document.documentElement || window.document.body
            //文档内容实际高度（包括超出视窗的溢出部分）
            let scrollHeight = Math.max(dom.scrollHeight, dom.scrollHeight);
            //滚动条滚动距离
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //窗口可视范围高度
            let clientHeight = dom.innerHeight || Math.min(dom.clientHeight,dom.clientHeight);
            if(clientHeight + scrollTop+10 >= scrollHeight){
                if(this.pagination.page >= this.pagination.pageSize ) return
                this.pagination.page++
                this.fetch()
            }
        },
        onRefresh() {
            this.pagination.page = 1
            this.fetch()
            setTimeout(() => {
                this.isLoading = false;
            }, 1000);
        },
        checkView(item) {
            const data = this.query
            const payload = {
                qt_id: data.qt_id,
                section_id: data.section_id,
                flag: data.flag,
                chapter_id: data.chapter_id,
                end_time: data.end_time,
                cq_id: data.cq_id,
                ucqid: data.ucqid,
                status: data.status,
                isShowSubmit: false,
                titleName: data.titleName,
                type: 'check',
                isConsolidation: true,
                consolidationId: item.id,
                workScore: item.score,
                isHistory: true
            }
            this.$router.push({path:'/questionPaper1',query: { payload: encodeURIComponent(JSON.stringify(payload)) }})
        },
        handleBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  min-height: 100%;
  background: #f0f4f5;;
}
.header {
    box-sizing: border-box;
    padding: 0 10px 0 20px;
    background: #ffffff;
}
.line {
    width: 100%;
    height: 1px;
    background: #E3E8E9;
}
.main {
    width: 100%;
    padding: 8px 12px;
    box-sizing: border-box;
    .section {
        width: 100%;
        box-sizing: border-box;
        padding: 8px;
        background: #ffffff;
        display: flex;
        justify-content: space-around;
        .sectionLi {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #848586;
            font-size: 13px;
            .sectionValue {
                color: #202020;
                font-size: 15px;
                margin-top: 4px;
                font-weight: 600;
                &.fail {
                    color: #ff8982;
                }
                &.success {
                    color: #10b881;
                }
            }
        }
    }
    .historyDataList {
        min-height: calc(100vh - 20vh - 42px - 20px);
        .historyDataLi {
            margin-top: 8px;
            background: #ffffff;
            padding: 12px;
            box-sizing: border-box;
            font-size: 13px;
            color: #848586;
            position: relative;
            .actionData {
                display: flex;
                padding: 12px;
                box-sizing: border-box;
                align-items: center;
                background-color: #F6F7F9;

                .dataScore {
                    padding: 2px 20px 2px 8px;
                    box-sizing: border-box;
                    border-right: 1px solid #DADCE0;
                    .dataValue {
                        font-size: 24px;
                        color: #286BFF;
                        margin-right: 4px;
                    }
                    div {
                        margin-top: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
                .section {
                    background-color: initial;
                    width: auto;
                    flex: 1;
                }
            }
            .actionTime {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 8px;
                font-size: 13px;
                .time > span {
                    margin-left: 4px;
                }
            }
            .tag {
                position: absolute;
                left: 0;
                top: 0;
                padding: 2px 8px;
                background: #10b881;
                border-radius: 8px 0px 8px 0px;
                color: #FFFFFF;
                font-size: 10px;
                &.fail {
                    background: #ff8982;
                }
            }
        }
    }
}
.btn {
    padding: 4px 12px;
    box-sizing: border-box;
    color: #286BFF;
    background-color: #EAF1FF;
    border-radius: 100px;
}
.borderRadius8 {
    border-radius: 8px;
}
.colorFFF {
    color: #ffffff;
}
</style>